import tempStorage from 'usage-tracker-core/containers/tempStorage';
import { getTrackingClient } from './dependencies';
export const getBaseTrackingClient = user => getTrackingClient({
  storage: tempStorage,
  user
});